import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ActivityCardProps {
  title: string;
  description: string;
  benefits?: string[];
  slug: string;
  colorAccent: 'blue' | 'coral' | 'green';
  icon: React.ReactNode;
  image?: string;
  index: number;
}
export function ActivityCard({
  title,
  description,
  slug,
  colorAccent,
  icon,
  image
}: ActivityCardProps) {
  const solidBgs = {
    blue: 'bg-brand-blue',
    coral: 'bg-brand-coral',
    green: 'bg-brand-green'
  };
  return <div data-component="COMP-05-ActivityCard" className="flex flex-col bg-white rounded-2xl overflow-hidden shadow-sm border border-navy-50" data-id="element-28">
      <div className={`h-56 w-full ${solidBgs[colorAccent]} relative flex items-center justify-center overflow-hidden`} data-id="element-29">
        {image ? <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-30" /> : <div className="text-white/30 transform scale-150" data-id="element-31">{icon}</div>}
      </div>

      <div className="p-8 flex-1 flex flex-col" data-id="element-32">
        <h3 className="text-2xl font-bold text-navy-900 mb-3" data-id="element-33">{title}</h3>
        <p className="text-navy-600 mb-6 flex-1" data-id="element-34">{description}</p>

        <Link to={`/activities/${slug}`} className="inline-flex items-center justify-center w-full py-4 rounded-lg font-bold transition-colors duration-300 bg-navy-50 text-navy-900 hover:bg-navy-900 hover:text-white active:bg-navy-800 group" aria-label={`Learn more about ${title}`} data-id="element-35">
          Learn More
          <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-36" />
        </Link>
      </div>
    </div>;
}